import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Redirect({ handleBuyRizz }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract query parameters safely
  const rawSearch = location.search;

  const fixedSearch = rawSearch.replace(/\?([^=]+)=/, (_, key) => `&${key}=`).replace('?&', '?');
  const params = new URLSearchParams(fixedSearch);

  // Clean and normalize status value
  const statusParam = params.get("status") || "";
  const status = statusParam.split("?")[0].toLowerCase();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/token/rzto");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <div
        style={{
          backgroundImage: `url(/images/main-background.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1,
          filter: "blur(10px)",
        }}
      ></div>
      <div className="checkout-wrappers">
        <div className="checkout-container">
          <h2>{status === "success" ? "Transaction Status" : "Transaction Failed"}</h2>
          {status === "success" && (
            <p>
              We are currently verifying your transaction status. You will receive an email notification once the token transfer is successfully completed.
            </p>
          )}
          <button className="btn btn-warning mt-3" onClick={() => navigate("/token/transactions")}>
            Go to Homepage
          </button>
        </div>
      </div>
    </>
  );
}
